module.exports = __webpack_public_path__ + "img/credit-card.56c19b28.svg";